/**
 * Índice de Regulación Bajo Presión — client-side mirror of the
 * backend bank (kept minimal — the backend is the source of truth
 * for scoring; this file is only used to render the UI shell).
 *
 * Real questions are fetched from GET /api/regulation/questions/:arche
 * on demand so we can update copy without a redeploy. This mirror is
 * used only for the intro card + fallback if the network call fails.
 */

export const REGULATION_SCALE = [
  { value: 1, label: "Nunca" },
  { value: 2, label: "Rara vez" },
  { value: 3, label: "A veces" },
  { value: 4, label: "Frecuentemente" },
  { value: 5, label: "Casi siempre" },
];

export const REGULATION_BANDS = [
  {
    id: "consolidada",
    min: 76,
    max: 100,
    label: "Regulación consolidada",
    short: "Consolidada",
    color: "#29BC9B",
    narrative:
      "Tu estrategia opera con madurez la mayor parte del tiempo. El Mapa te ayudará a sostenerla cuando la exigencia se dispare.",
  },
  {
    id: "en-camino",
    min: 51,
    max: 75,
    label: "En camino",
    short: "En camino",
    color: "#8BD9C2",
    narrative:
      "Tu fortaleza está desarrollada, pero bajo presión aún se te escapa. Aquí es donde el Mapa acelera tu evolución.",
  },
  {
    id: "punto-de-partida",
    min: 26,
    max: 50,
    label: "Punto de partida",
    short: "Punto de partida",
    color: "#F5B84C",
    narrative:
      "Tu patrón de bloqueo aparece con frecuencia. Aquí empieza tu evolución estratégica.",
  },
  {
    id: "alerta",
    min: 0,
    max: 25,
    label: "Alerta estratégica",
    short: "Alerta",
    color: "#F07268",
    narrative:
      "Tu patrón sombra domina bajo presión. El Mapa es una prioridad.",
  },
];

export function bandForScore(score) {
  const s = Math.max(0, Math.min(100, Number(score) || 0));
  return (
    REGULATION_BANDS.find((b) => s >= b.min && s <= b.max) ||
    REGULATION_BANDS[REGULATION_BANDS.length - 1]
  );
}
